import { ErrorWithCode } from '@vista-digital/utilities';
/**
 * Represents an error returned by OCAPI.
 */
export class OcapiError extends ErrorWithCode {
    constructor(errorCode, message) {
        super(errorCode, message);
    }
}
//# sourceMappingURL=ocapi-error.js.map